import { type HeadFC } from 'gatsby'
import React, { useEffect } from 'react'
import { RealEstateDataPageComponent } from 'types'
import { useLocation } from '@reach/router'
import $ from 'jquery'

export const Head: HeadFC = ({ pageContext, serverData }) => {
  const {
    components,
    custom_seo_title,
    global_data: {
      logoShare,
      favicon,
      domain,
      pageConfig: {
        colors: { primaryColor, secondaryColor, tertiaryColor, backgroundColor },
        design: {
          border1,
          border2,
          border3,
          border4,
          imageBorder1,
          imageBorder2,
          imageBorder3,
          imageBorder4,
          componentMargins0,
          h1,
          h2,
          h3,
          h4,
          h5,
          p,
          p_bold,
          a,
          font_size,
          buttonPadding1 = 0,
          buttonPadding2 = 0,
          buttonUnderline = false,
          buttonItalic = false,
          global,
        },
      },
    },
  } = pageContext as any

  const {
    global_data: {
      content: { seo },
    },
  } = pageContext as any

  const getTitleHTML = () => {
    if (
      components?.find((component: RealEstateDataPageComponent) =>
        component.type.toLowerCase().includes('prehome'),
      )
    ) {
      return custom_seo_title || 'Página de inicio'
    } else {
      return seo.seo_title
        ? seo.seo_title +
            ((pageContext as any).seo_title
              ? ' | ' + (pageContext as any).seo_title
              : ' | ' + ((serverData as any)?.openGraph?.title || (pageContext as any).title))
        : (serverData as any)?.title || (pageContext as any).title
    }
  }
  const { pathname } = useLocation()

  useEffect(() => {
    $('html, body').animate({ scrollTop: 0 }, 'slow')
  }, [pathname])

  return (
    <>
      <link
        rel="icon"
        type="image/x-icon"
        href={favicon}
      />
      <meta
        name="description"
        content={seo?.seo_description}
      />
      <meta
        property="og:title"
        content={`${getTitleHTML()}`}
      />
      <meta
        property="og:description"
        content={(serverData as any)?.openGraph?.description || seo?.seo_description}
      />
      <meta
        property="og:type"
        content={(serverData as any)?.openGraph?.type ?? 'website'}
      />
      <meta
        property="og:image"
        content={(serverData as any)?.openGraph?.image || logoShare}
      />
      <link
        data-react-helmet="true"
        rel="canonical"
        href={'https://' + domain}
      />
      <meta
        name="keywords"
        content={seo.seo_keywords.join(',')}
      />
      <meta
        name="author"
        content={'Mediacore®'}
      />
      <meta
        name="copyright"
        content={'Mediacore®'}
      />
      <meta
        name="publisher"
        content={'Mediacore®'}
      />
      <meta
        name="robots"
        content="index,follow"
      />
      <meta
        name="googlebot"
        content="index,follow"
      />
      <style type="text/css">{`
          @font-face {
            font-family: h1CustomFont;
            src: url(${h1.file});
			font-display: swap;
          }
          @font-face {
            font-family: h2CustomFont;
            src: url(${h2.file});
			font-display: swap;
          }
          @font-face {
            font-family: h3CustomFont;
            src: url(${h3.file});
			font-display: swap;
          }
          @font-face {
            font-family: h4CustomFont;
            src: url(${h4.file});
			  font-display: swap;
          }
          @font-face {
            font-family: h5CustomFont;
            src: url(${h5.file});
			font-display: swap;
          }
          @font-face {
            font-family: pCustomFont;
            src: url(${p.file});
			font-display: swap;
          }
          @font-face {
            font-family: pBoldCustomFont;
            font-weight:500;
            src: url(${p_bold?.file || p.file});
			font-display: swap;
          }
          @font-face {
            font-family: aCustomFont;
            src: url(${a?.file || p.file});
			font-display: swap;
          }
          @font-face {
            font-family: globalCustomFont;
            src: url(${global.file});
			font-display: swap;
          }
      `}</style>
      <style>
        {`\
          :root{\
            --primaryColor: ${primaryColor};\
            --secondaryColor: ${secondaryColor};\
            --tertiaryColor: ${tertiaryColor};\
            --backgroundColor: ${backgroundColor || '#f8f8f8'};\
            --grayColor: #6b6b6b;\
            --customBorders: ${border1}px ${border2}px ${border3}px ${border4}px;\
            --borderImages: ${imageBorder1}px ${imageBorder2}px ${imageBorder3}px ${imageBorder4}px;\
            --componentMargins:${componentMargins0}vh;\
            --globalfontSize: var(--fontSize${font_size || 'M'});\
            --border1: ${border1}px;\
            --border2: ${border2}px;\
            --border3: ${border3}px;\
            --border4: ${border4}px;\
            --paddingButton: ${buttonPadding1}rem ${buttonPadding2}rem;\
            --paddingButtonMobile: ${buttonPadding1 * 1.2}rem ${buttonPadding2}rem;\
            --buttonUnderline: ${buttonUnderline ? 'underline;' : 'none;'};\
            --buttonItalic: ${buttonItalic ? 'italic;' : 'none;'};\
            --h1LSpacing: ${h1.letterSpacing + 'px' || 0};\
            --h2LSpacing: ${h2.letterSpacing + 'px' || 0};\
            --h3LSpacing: ${h3.letterSpacing + 'px' || 0};\
            --h4LSpacing: ${h4.letterSpacing + 'px' || 0};\
            --h5LSpacing: ${h5.letterSpacing + 'px' || 0};\
            --pLSpacing: ${p.letterSpacing + 'px' || 0};\
            --aLSpacing: ${a?.letterSpacing + 'px' || 0};\
            --globalLSpacing: ${global.letterSpacing + 'px' || 0};\
            --h1Uppercase: ${h1.upperCase ? 'uppercase' : 'none'};\
            --h2Uppercase: ${h2.upperCase ? 'uppercase' : 'none'};\
            --h3Uppercase: ${h3.upperCase ? 'uppercase' : 'none'};\
            --h4Uppercase: ${h4.upperCase ? 'uppercase' : 'none'};\
            --h5Uppercase: ${h5.upperCase ? 'uppercase' : 'none'};\
            --pUppercase: ${p.upperCase ? 'uppercase' : 'none'};\
            --aUppercase: ${a?.upperCase ? 'uppercase' : 'none'};\
            --globalUppercase: ${global.upperCase ? 'uppercase' : 'none'};\
            --h1Size: ${h1.size && h1.size !== '0' ? `${h1.size}rem` : '3rem'};\
            --h2Size: ${h2.size && h2.size !== '0' ? `${h2.size}rem` : '2.48rem'};\
            --h3Size: ${h3.size && h3.size !== '0' ? `${h3.size}rem` : '2rem'};\
            --h4Size: ${h4.size && h4.size !== '0' ? `${h4.size}rem` : '1.6rem'};\
            --h5Size: ${h5.size && h5.size !== '0' ? `${h5.size}rem` : '1.4rem'};\
            --pSize: ${p.size && p.size !== '0' ? `${p.size}rem` : '1rem'};\
          }\
        `}
      </style>
      {/* <title>{((pageContext as any).seo_title + (seo?.seo_title ? ' | ' + seo?.seo_title : '')) || (pageContext as any).title}</title> */}
      <title>{`${getTitleHTML()}`}</title>
    </>
  )
}
